const innerContent = document.querySelector('.innerContent');

document.addEventListener("DOMContentLoaded", function () {
    const innerContent = document.querySelector('.innerContent');
    if (innerContent == null) return;

    const links = innerContent.querySelectorAll('a:not(.btn)[href*="#"]');

    links.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            const targetId = this.getAttribute('href').split('#')[1]; // Remove #
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const offset = 5 * 16; // Convert rem to px
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
});
